import { Component, Input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'xemex-no-items-found',
  imports: [MatIconModule, MatButtonModule, RouterLink, TranslateModule],
  templateUrl: './no-items-found.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './no-items-found.component.scss',
})
export class NoItemsFoundComponent {
  @Input() NoItemsIllustration: string = 'loop';
  @Input() message: string | null = null;
  @Input() showRefresh: boolean = true;
  /**
   * Compact mode: renders a small inline placeholder (a single illustration with an optional
   * message) instead of the full-size illustration, heading, and refresh button. Use inside
   * cards where a large empty state would dominate the layout.
   */
  @Input() compact: boolean = false;
  /** Router commands for a link under the message, to where the missing items can be added. */
  @Input() link: unknown[] | null = null;
  /** Translation key of the link's text; the link shows only with both set. */
  @Input() linkLabel: string | null = null;
  refresh = output();

  constructor() {}

  onRefresh() {
    this.refresh.emit();
  }
}
